import { createFileRoute } from "@tanstack/react-router";
import { Link } from "@tanstack/react-router";
import { buttonStyles } from "@simurgh/feathers/ui/button";
import { useTranslation } from "react-i18next";
import { LocaleProvider, useLocale } from ":shared/lib/locale";
import { type SupportedLocale } from ":shared/lib/i18n";

export const Route = createFileRoute("/$")({
	component: NotFoundWrapperComponent,
});

function NotFoundWrapperComponent() {
	const { locale } = Route.useParams() as any;

	return (
		<LocaleProvider locale={locale as SupportedLocale}>
			<NotFoundComponent />
		</LocaleProvider>
	);
}

function NotFoundComponent() {
	const { t } = useTranslation();
	const { locale } = useLocale();

	return (
		<>
			<title>
				{t("pages.notFound.title")} - {t("app.name")}
			</title>
			<meta name="description" content={t("pages.notFound.description")} />
			<div className="flex flex-col items-center justify-center min-h-[60vh] px-4">
				<div className="text-center space-y-6 max-w-md">
					<div className="space-y-2">
						<h1 className="text-6xl font-bold text-primary">
							{t("pages.notFound.heading")}
						</h1>
						<h2 className="text-2xl font-semibold">
							{t("pages.notFound.subheading")}
						</h2>
						<p className="text-muted-fg">{t("pages.notFound.description")}</p>
					</div>
					<div className="flex gap-4 justify-center">
						<Link
							className={buttonStyles({ intent: "primary" })}
							to="/$locale/dashboard"
							params={{ locale }}
						>
							{t("pages.notFound.goToDashboard")}
						</Link>
						<Link className={buttonStyles({ intent: "outline" })} to="/">
							{t("pages.notFound.goHome")}
						</Link>
					</div>
				</div>
			</div>
		</>
	);
}
